export default __webpack_public_path__ + "static/media/contact.3a25b849.svg";